import { posthog } from 'posthog-js'
import getTrackingParams from 'src/utils/getTrackingParams'

const logToPostHog = (message: string, props?: { [key: string]: string | undefined }): void => {
  const utm_medium = getTrackingParams(window.location)['utm_medium']

  posthog.capture(message, { utm_medium, ...props })
}

export default logToPostHog
